import { UnsavedChangesProtection } from 'v5/patterns/forms/unsaved-changes/UnsavedChangesProtection';
import { Dialog, DialogContentHeadless } from 'v5/design-system/Dialog';
import { EditCalloutDialogContent } from 'v5/features/callouts/EditCalloutDialogContent';
import { MountElementProps } from 'v5/messages/mount-element';
import { Callout } from '__types__/v1/models/Callout';
import { CalloutEditFormData } from 'v5/features/callouts/callout-create.types';
import { WithServices } from 'v5/platform/ts/services';
import { WithResourceTypeService } from 'v5/services/internal/ResourceTypeService/ResourceTypeService';
import { WithAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';
import { WithEnterpriseService } from 'v5/services/io/EnterpriseService/EnterpriseService';
import { WithCalloutsService } from 'v5/services/io/CalloutsService/CalloutsService';

export interface EditCalloutDialogProps
  extends WithServices<
    [
      WithResourceTypeService,
      WithCalloutsService,
      WithAppScopeService,
      WithEnterpriseService
    ]
  > {
  callout: Callout;
  onSubmit?: (data: CalloutEditFormData) => Promise<void> | void;
}

export function EditCalloutDialog({
  open,
  onOpenChange,
  onSubmit,
  callout,
  services
}: EditCalloutDialogProps & MountElementProps) {
  return (
    <UnsavedChangesProtection
      open={open}
      onOpenChange={onOpenChange}
      beforeUnloadMessage="You have unsaved changes in the callout form!"
    >
      {dialogProps => (
        <Dialog {...dialogProps}>
          <DialogContentHeadless>
            <EditCalloutDialogContent
              open={dialogProps.open}
              callout={callout}
              onSubmit={onSubmit}
              services={services}
            />
          </DialogContentHeadless>
        </Dialog>
      )}
    </UnsavedChangesProtection>
  );
}
